import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";

// Config comes from .env.local (see .env.example). The defaults point to the legacy
// "tehnocin" project so the site keeps working until the new project is set up.
const env = process.env;

export const firebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBqN7TanHmbuBdl9-XP0QhqNYCO8U6lx9I",
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tehnocin.firebaseapp.com",
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID || "tehnocin",
  storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tehnocin.appspot.com",
  messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "46401811042",
  appId: env.REACT_APP_FIREBASE_APP_ID || "1:46401811042:web:34b53cac2e5e950296573b",
  measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-CE1J8QS473",
};

export const usingEmulators = env.REACT_APP_USE_FIREBASE_EMULATORS === "true";

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

if (usingEmulators) {
  const host = env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  connectFirestoreEmulator(db, host, 8080);
  connectStorageEmulator(storage, host, 9199);
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
}

export { app, db, storage, auth };
